/*
 * Application State should be all within this file.
 */
function getUnixTimestamp() {
  return Math.floor(Date.now() / 1000);
}

function createCodeObject(payload) {
  return {
    code: payload.code,
    tsLastUpdated: getUnixTimestamp(),
    tsCreated: getUnixTimestamp(),
    score: payload?.score || 0
  };
}

const app = {
  state: {
    entryMapped: false,
    codes: [],
    canvasUserImage: "",
    userImage: "",
    userId: "",
    courseId: ""
  },
  mutations: {
    // Sets the codes array in the state from the datastore
    SET_CODES(state, codes) {
      state.codes = codes;
      state.entryMapped = true;
    },
    // Adds an code to the codes array in the stat
    // payload is
    // - asdfa
    // - dafasf
    UPDATE_CODE(state, payload) {
      //console.log("[UPDATE_CODE] payload", payload);
      // find code in state.codes
      //let codeObject = state.codes.filter((c) => c.code === codePayload.code);
      const index = state.codes.findIndex((c) => c.code === payload.code);

      if (index !== -1) {
        //console.log(">> UPDATE <<");
        // UPDATE
        state.codes[index] = {
          ...createCodeObject(payload),
          ...payload,
          ...{ tsLastUpdated: getUnixTimestamp() }
        };
      } else {
        // CREATE
        let codeObject = createCodeObject(payload);

        state.codes.push(codeObject);

        //console.log("<< CREATE <<");
      }

      //update startedQuestions

      // everytime they answer a question update datastore
      // question seed property to keep same 5 questions
      // score out of 5
      // lockout
    },
    // Sets the canvas user image from canvas
    SET_CANVAS_USER_IMAGE(state, imageUrl) {
      //console.log("[SET_CANVAS_USER_IMAGE] canvas imageUrl", imageUrl);
      state.canvasUserImage = imageUrl;
    },
    // Sets the user image from the datastore
    SET_USER_IMAGE(state, imageUrl) {
      //console.log("[SET_USER_IMAGE] datastore imageUrl", imageUrl);
      state.userImage = imageUrl;
    },
    SET_CANVAS_ID(state, userId) {
      //console.log("[setCanvasId] canvasId", userId);
      state.userId = userId;
    },
    SET_COURSE_ID(state, courseId) {
      state.courseId = courseId;
    }
  },
  actions: {
    addCode({ commit }, codePayload) {
      commit("UPDATE_CODE", codePayload);
    },
    setCanvasId({ commit }, canvasId) {
      commit("SET_CANVAS_ID", canvasId);
    },
    updateCode({ commit }, codePayload) {
      commit("UPDATE_CODE", codePayload);
    },
    setUserImage({ commit }, imageUrl) {
      commit("SET_USER_IMAGE", imageUrl);
    },
    setCanvasUserImage({ commit }, imageUrl) {
      commit("SET_CANVAS_USER_IMAGE", imageUrl);
    },
    setCourseId({ commit }, courseId) {
      commit("SET_COURSE_ID", courseId);
    },
    mapFromDatastore({ commit, state }, payload) {
      /*
       * This is called whenever the Datastore/entry changes.
       * This is an opportunity for you to map stored values
       * back into your state.
       */
      let _payload = "";
      try {
        _payload = JSON.parse(payload);
      } catch (e) {
        _payload = payload;
      }

      //console.log("[mapFromDatastore] _payload", _payload);

      /*
       * Call a mutation to put your datastore payload into your app state
       */
      commit("SET_CODES", _payload?.codes ?? state.codes);
      commit("SET_USER_IMAGE", _payload?.userImage ?? state.userImage);
      commit("SET_CANVAS_ID", _payload?.userId ?? state.userId);
      commit("SET_COURSE_ID", _payload?.courseId ?? state.courseId);
    }
  },
  getters: {
    getCodes(state) {
      return state.codes;
    },
    getUserId(state) {
      return state.userId;
    },
    getUserImage(state) {
      return state.userImage;
    },
    getEntryMapped(state) {
      return state.entryMapped;
    },
    getCourseId(state) {
      return state.courseId;
    },
    mapToDatastore(state, rootGetters) {
      /*
       * Datastore Payload is only used whenever you're using the
       * Datastore (or Datasheets). This is an object
       */

      let payload = {
        userId: state.userId,
        fullname: rootGetters.getFullname,
        codes: state.codes,
        userImage: state.userImage,
        courseId: state.courseId
      };
      //console.log("Payload", payload);

      payload = JSON.stringify(payload);
      return payload;
    }
  }
};

export default app;
